import type { FaireProductEntity } from "../../entity_types/product";

export const p_vwssret42y: FaireProductEntity = {
  token: "p_vwssret42y",
  type: "product",
  name: "ELLA CHAIN",
  brandToken: "b_p55ppsxvzv",
  brandName: "BAGS-2-SLAY",
  imageUrl:
    "https://cdn.faire.com/fastly/c27ab8ade21012470dd4459275abdcbcea0fdf85095f544f0346fb829f77fb4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/849300cec6628f515c850eb2d8a25cdebb211cfa719229dcfc670e57774d8245.jpeg",
    "https://cdn.faire.com/fastly/1ff8f780415ab14a0d594555b6a81da395255fa6883feacf31c2898a4f1c9a61.webp",
    "https://cdn.faire.com/fastly/2c5e61a1a45f4fa2ff656fbc426ee3e6d4d508acbbc2f665faf2d93bad2ace41.webp",
  ],
  priceDollars: 9,
  description:
    "Women's Fashion Dainty 5mm Twisted Chain Necklaces Brass 24K Gold Plated Jewelry.\n\nWater resistant 💧\nMaterials: Stainless steel \nMeasurements: 16\", 5mm thick\nClosure: Lobster clasp\nAllergy Information: Hypoallergenic\n",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:57.183Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
